// Cuenta "sesiones" de uso para gatear el banner de instalación PWA (no
// molestar al usuario en su primera visita). Una sesión nueva = una visita al
// menos SESSION_GAP_MS después de la anterior. Persistido en localStorage.
// Namespace `orborix.speak.*` para no colisionar con otras apps del monorepo.

const COUNT_KEY = 'orborix.speak.pwa.sessionCount';
const LAST_KEY = 'orborix.speak.pwa.lastSessionAt';
/** Gap mínimo entre sesiones para que cuenten como nueva. 30 min. */
const SESSION_GAP_MS = 30 * 60 * 1000;

export function recordPwaSession(): number {
  if (typeof window === 'undefined') return 0;
  try {
    const now = Date.now();
    const last = Number(window.localStorage.getItem(LAST_KEY) ?? 0);
    const count = Number(window.localStorage.getItem(COUNT_KEY) ?? 0);
    if (!last || now - last > SESSION_GAP_MS) {
      const next = count + 1;
      window.localStorage.setItem(COUNT_KEY, String(next));
      window.localStorage.setItem(LAST_KEY, String(now));
      return next;
    }
    window.localStorage.setItem(LAST_KEY, String(now));
    return count;
  } catch {
    return 0;
  }
}

export function getPwaSessionCount(): number {
  if (typeof window === 'undefined') return 0;
  try {
    return Number(window.localStorage.getItem(COUNT_KEY) ?? 0);
  } catch {
    return 0;
  }
}
